var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import cardMap from '@app/games/shared/card-map';
import { cardValues } from '@app/_v2/games/baccarat/models/card-values.model';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
var MersenneTwister = require('mersennetwister');
var log = debug('edg:reply-baccarat');
var ReplyBaccaratComponent = /** @class */ (function (_super) {
    __extends(ReplyBaccaratComponent, _super);
    function ReplyBaccaratComponent(socket, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.data = null;
        _this.deck = [];
        return _this;
    }
    ReplyBaccaratComponent.prototype.initialize = function (data) {
        if (data.game !== 'baccarat') {
            this._error = true;
            return;
        }
        this.data = data;
        this.prepareDeck(this.data.gameData.numDealedCards);
    };
    ReplyBaccaratComponent.prototype.generateGame = function () {
        var deck = this.reconstructDeck(this.serverSeed, this.playerSeed);
        var data = {
            gameData: {
                playerCards: [deck[0], deck[2]],
                dealerCards: [deck[1], deck[3]],
                shuffledDeck: deck,
                generated: true,
                numDealedCards: 4,
            },
            game: 'baccarat',
        };
        var playerValue = this.getPlayerValue(data);
        var dealerValue = this.getDealerValue(data);
        if (playerValue === 8 || playerValue === 9 || dealerValue === 8 || dealerValue === 9) {
            // If either the Player or Banker have 8 or 9 points, it is referred to as a "natural."
            // If there is at least one natural, then both hands will stand.
        }
        else if (playerValue <= 5) {
            // Otherwise, if the Player's total is 5 or less, then the Player hand will draw one more card,
            // otherwise, with 6 or 7 points, the Player hand stands.
            var card = deck[data.gameData.numDealedCards];
            data.gameData.numDealedCards++;
            data.gameData.playerCards.push(card);
            // If the Player does draw a third card, then use the Banker will use his positional advantage to decide
            // whether to take a third card according to his total and the third card drawn to the Player,
            // according to the following table.
            // @link https://wizardofodds.com/games/baccarat/basics/
            if (this.shouldBankerDrawAfterThirdCard(dealerValue, this.getCardValue(card))) {
                var card_ = deck[data.gameData.numDealedCards];
                data.gameData.numDealedCards++;
                data.gameData.dealerCards.push(card_);
            }
        }
        else if (dealerValue <= 5) {
            // If the Player hand stands with 6 or 7 points, then the Banker hand will draw a third card on
            // a total of 5 or less. Otherwise, with 6 or 7 points, the Banker will stand.
            var card = deck[data.gameData.numDealedCards];
            data.gameData.numDealedCards++;
            data.gameData.dealerCards.push(card);
        }
        this.initialize(data);
    };
    ReplyBaccaratComponent.prototype.shouldBankerDrawAfterThirdCard = function (score, card) {
        return ([0, 1, 2].includes(score) ||
            (score === 3 && card !== 8) ||
            (score === 4 && ![0, 1, 8, 9].includes(card)) ||
            (score === 5 && [4, 5, 6, 7].includes(card)) ||
            (score === 6 && [6, 7].includes(card)));
    };
    ReplyBaccaratComponent.prototype.prepareDeck = function (startIndex) {
        this.deck = [];
        var deck = this.data.gameData.shuffledDeck;
        if (deck.length > 0) {
            for (var i = startIndex; i < startIndex + 4; i++) {
                this.deck.push(deck[i]);
            }
        }
        this._loading = false;
    };
    ReplyBaccaratComponent.prototype.getCardName = function (card) {
        return cardMap[card % 52];
    };
    ReplyBaccaratComponent.prototype.getDealerValue = function (game) {
        return this.getHandValue(game.gameData.dealerCards);
    };
    ReplyBaccaratComponent.prototype.getPlayerValue = function (game) {
        return this.getHandValue(game.gameData.playerCards);
    };
    ReplyBaccaratComponent.prototype.getHandValue = function (cards) {
        var sum = 0;
        cards.forEach(function (card) {
            sum += cardValues[card % 13];
        });
        if (sum > 9) {
            var stringed = String(sum);
            sum = Number(stringed.substring(1, stringed.length));
        }
        return sum;
    };
    ReplyBaccaratComponent.prototype.getDealerCardCount = function (handIndex) {
        if (!this.data || !this.data.gameData.dealerCards) {
            return 0;
        }
        return this.data.gameData.dealerCards.length;
    };
    ReplyBaccaratComponent.prototype.getCardValue = function (card) {
        return cardValues[card % 13];
    };
    ReplyBaccaratComponent.prototype.reconstructDeck = function (srvSeed, clientSeed) {
        var deck = [];
        for (var i = 0; i < 8 * 52; i++) {
            // 8 decks
            deck.push(i);
        }
        return this.shuffleDeck(deck, srvSeed, clientSeed);
    };
    ReplyBaccaratComponent.prototype.getCardCount = function () {
        if (!this.data || !this.data.gameData.playerCards) {
            return 0;
        }
        return this.data.gameData.playerCards.length;
    };
    ReplyBaccaratComponent.prototype.shuffleDeck = function (deck, serverSeed, clientSeed) {
        serverSeed = serverSeed.replace('0x', '');
        clientSeed = clientSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted).map(function (item) { return parseInt(item, 16); });
        var mt = new MersenneTwister();
        mt.seedArray(seedsCombined);
        for (var i = 0; i < 800000; i++) {
            mt.real();
        }
        var shuffledDeck = deck.slice(0);
        for (var i = shuffledDeck.length - 1; i > 0; i -= 1) {
            var j = Math.floor(mt.real() * (i + 1));
            var temp = shuffledDeck[i];
            shuffledDeck[i] = shuffledDeck[j];
            shuffledDeck[j] = temp;
        }
        return shuffledDeck;
    };
    return ReplyBaccaratComponent;
}(ReplyAbstractComponent));
export { ReplyBaccaratComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-baccarat.component.ts.pre-build-optimizer.js